import { render, staticRenderFns } from "./look-up-detail-add-edit.vue?vue&type=template&id=821b72e6&scoped=true"
import script from "./look-up-detail-add-edit.vue?vue&type=script&lang=js"
export * from "./look-up-detail-add-edit.vue?vue&type=script&lang=js"
import style0 from "./look-up-detail-add-edit.vue?vue&type=style&index=0&id=821b72e6&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "821b72e6",
  null
  
)

export default component.exports